import { createModule } from 'terrific-singleton';
import { TerrificSpec } from 'terrific-singleton/terrific-module';

@createModule('StageCampaign')
/**
 * table-filter module implementation.
 *
 * @author Christoph Merkelbach <christoph.merkelbach@namics.com>
 */
export class StageCampaign extends TerrificSpec {
	ticking: boolean = false;
	scrollArea: JQuery;

	/**
	 * start method, called on terrific bootstap
	 *
	 * @param {Object} resolve  function to call at the end of component start
	 * @returns {void}
	 */
	start(resolve: Function) {
		const $ctx = $(this._ctx);
		this.scrollArea = $('.js-m-stage-campaign__parallax', $ctx);
		this.ticking = false;

		window.addEventListener('scroll', this.requestScrollTick.bind(this), false);
		window.addEventListener('resize', this.onResize.bind(this), false);

		this.requestScrollTick();

		resolve();
	}

	/**
	 * Debounces animation with browser's requestAnimation Frame to provide performance and
	 * keep page smoothly scrollable even on older machines
	 */
	requestScrollTick() {
		if (!this.ticking) {
			requestAnimationFrame(this.scrollUpdate.bind(this));
			this.ticking = true;
		}
	}

	onResize() {
		this.requestScrollTick();
	}

	scrollUpdate() {
		const bgPosition = $(window).scrollTop() * 0.5;

		this.scrollArea.css({
			transform: 'translate3d(0, ' + bgPosition + 'px, 0)',
		});

		this.ticking = false;
	}

	/**
	 * stop method, called on terrific stop
	 *
	 * @returns {void}
	 */
	stop() {}
}
